<template>
  <div class="storeinformation">
    <div
      class="member_box"
      :style="{
        'background-color': datas.backColor,
        'background-image': isMember&&datas.bgImg ? 'url(' + datas.bgImg + ')' : '',
        'padding-top': datas.paddingTop + 'px',
        'padding-bottom': datas.paddingBottom + 'px',
        'padding-left': datas.paddingLeft + 'px',
        'padding-right': datas.paddingRight + 'px',
        'border-style': datas.borderStyle,
        'border-color': datas.borderColor,
        'border-width': datas.borderLineWeight + 'px',
        'border-radius': datas.borderRadius + 'px',
        'margin-top': datas.marginTop + 'px',
        'margin-bottom': datas.marginBottom + 'px',
        'margin-left': datas.marginLeft + 'px',
        'margin-right': datas.marginRight + 'px'
      }"
    >
    <div v-if="!isMember" class="c-fc-center bg-white c-m-lr-30 c-p-20 c-b-r-30">
      <img src="@/assets/images/star.png" class="c-w-50"></img>
      <div class="tc m-t-20">成为会员, 享受更多优惠及礼遇</div>
      <div class="tc m-t-20">
        <van-button
          color="var(--tc)"
          size="small"
          @click="handleToRegisterMember"
          >注册/登录会员</van-button
        >
      </div>
    </div>
      <section v-else class="f-bt member_con">
        <!-- 内容 -->
        <div class="member_left_con">
          <div style="display: flex">
            <div v-if="datas.styleType === 1" class="user_img_con">
              <img :src="memberInfo.WxUserImg" alt="">
            </div>
            <div
              class="member_info_con"
              :style="{ 'margin-bottom': datas.styleType === 1 ? 0 : '50px' }"
            >
              <div
                class="main_con"
                :style="{
                  'font-size': datas.wordSize + 'px',
                  'font-weight': datas.isBold ? 'bold' : 'normal',
                  'font-style': datas.isTilt ? 'italic' : 'normal',
                  'text-decoration': datas.isUnderLine ? 'underline' : 'none',
                  color: datas.wordColor,
                }"
              >
                {{ datas.mainContentType == 1 ?memberInfo.MobilePhone: memberInfo.MemberName  }}
              </div>
              <div
                :style="{
                  display: datas.styleType === 1 ? 'flex' : 'unset',
                  'font-size': datas.wordSizeSmallTitle + 'px',
                  'font-weight': datas.isBoldSmallTitle ? 'bold' : 'normal',
                  'font-style': datas.isTiltSmallTitle ? 'italic' : 'normal',
                  'text-decoration': datas.isUnderLineSmallTitle
                    ? 'underline'
                    : 'none',
                  color: datas.wordColorSmallTitle,
                }"
              >
                <div
                  v-if="handleSetShow(3)"
                  :class="[{ 'c-m-b-5': datas.styleType === 2 }, 'c-m-r-8']"
                >
                 {{'NO.'+memberInfo.CardCode}}
                </div>
              
              </div>
                 <div style="font-size: 12px;" v-if="handleSetShow(4)">总余额：{{memberInfo.Account}}</div>
                <div style="font-size: 12px;" v-if="handleSetShow(2)">可用积分：{{memberInfo.Integral}}</div>
                <div style="font-size: 12px;" v-if="handleSetShow(5)">累计积分：{{memberInfo.ConsumeIntegral}}</div>
            </div>
          </div>
          <div
            v-if="handleSetShow(1)"
            class="coupon_btn_con"
            :style="{
              'font-size': datas.wordSizeSmallTitle + 'px',
              'font-weight': datas.isBoldSmallTitle ? 'bold' : 'normal',
              'font-style': datas.isTiltSmallTitle ? 'italic' : 'normal',
              'text-decoration': datas.isUnderLineSmallTitle
                ? 'underline'
                : 'none'
            }"
            @click="handleToCoupon"
          >
            {{couponCount}}张礼券可用
          </div>
        </div>
        <div class="code_img_con" @click="handleShowQrCode">
          <div class="code_box">
						          <vue-qr :text="qrCode" class="qr_code"></vue-qr>

						<img class="click_img" src="@/assets/images/click.png" />
					</div>
          <div
            :style="{
              'font-size': datas.wordSizeCode + 'px',
              'font-weight': datas.isBoldCode ? 'bold' : 'normal',
              'font-style': datas.isTiltCode ? 'italic' : 'normal',
              'text-decoration': datas.isUnderLineCode ? 'underline' : 'none',
              color: datas.wordColorCode,
            }"
          >
            {{ datas.codeTitle }}
          </div>
        </div>
      </section>
    </div>
 <!-- 一码通弹窗 -->
    <cardCodeCom
      :show.sync="showCodeModal"
      :codeType="2"
    ></cardCodeCom>
  </div>
</template>

<script>
import {
  getUserCardInfo
} from "@/api/member";
import {getMyTicketCount} from '@/api/coupon'
import { handleSessionStorage,handleAuthUserInfo,handleLocalStorage } from "@/utils/index";
import cardCodeCom from "@/components/cardCodeCom";
import { setToken } from "@/utils/auth";

export default {
  name: "Memberinformation",
  props: {
    datas: Object,
  },
  components: { cardCodeCom },
  data() {
    return {
      memberInfo:{},
      isMember: false,
      showCode:false,
      qrCode:'222',
      couponCount:0,
      showCodeModal: false,
    };
  },
   watch: {
    "$store.state.vpnId"(val) {
      this.vpnId = val;
      this.handleInitMemberInfo()
      this.handleGetCouponCount()
    },
  },
  created() {
    this.vpnId = this.$store.state.vpnId;
    if(this.vpnId){
      this.handleInitMemberInfo()
      this.handleGetCouponCount()
    }
  },
  methods: {
    handleSetShow(type) {
      return this.datas.showContents.includes(type);
    },
    handleInitMemberInfo(){
      getUserCardInfo({ vpnId: this.vpnId }).then((res) => {
        if(res.Code){
          this.isMember=false
          return
        }
        if(res.Token){
           setToken(res.Token);
        }
          let info = handleSessionStorage.get("wxUserInfo")
          this.isMember=true
          this.memberInfo = {
            WxUserImg:info&&info.img,
            MemberName: res.MemberName,
            MobilePhone: res.MobilePhone,
            Account:res.Account,
            MemberAccountId:res.MemberAccountId,
            CardCode:res.CardCode,
            Integral:res.Integral,
            ConsumeIntegral:res.ConsumeIntegral,
          };
      });
    },
    handleGetCouponCount(){
      getMyTicketCount({vpnId:this.vpnId }).then(res=>{
        this.couponCount=res.AvalibleTicketTotal
      })
    },
    handleToRegisterMember() {
      const _this=this
      handleLocalStorage.set('registerAfterPage',{name:'HomePage'})
      
      handleAuthUserInfo(handleToNext)
      //   this.$emit('click', 'order');
      function handleToNext(){
        _this.$router.push({
          name: "ValidMember",
        })
      }
      
    },
    handleToCoupon(){
      this.$router.push({
        name: "MyCouponList",
      });
    },
    handleShowQrCode() {
				this.showCodeModal = true
			},
  },
};
</script>

<style scoped lang="scss">
.storeinformation {
  position: relative;
  .member_box {
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .member_con {
    .member_left_con {
      .user_img_con {
        margin-right: 15px;
        img {
          width: 80px;
          height: 80px;
          border-radius: 50%;
        }
      }
      .member_info_con {
        padding: 10px 0;
        
        .main_con {
          margin-bottom: 10px;
        }
      }
      .coupon_btn_con {
        background: var(--tc);
        color: #fff;
        border-radius: 30px;
        padding: 15px 30px;
        text-align: center;
        display: inline-block;
        margin-top: 40px;
      }
    }
    .code_img_con {
      display: flex;
      flex-direction: column;
      align-items: center;
      .qr_code{
      width: 140px;
      height:140px;
      vertical-align: top;
      border-radius: 18px;
      margin-bottom: 20px;
    }
    .code_box {
					width: 140px;
					height: 140px;
					border-radius: 18px;
					border: 2px solid #d8d8d8;
					// padding: 10px;
					margin-bottom: 12px;
					position: relative;

					.click_img {
						width: 40px;
						height: 40px;
						background: #FFFFFF;
						border-radius: 7px;
						position: absolute;
						top: 50%;
						left: 50%;
						margin-top: -20px;
						margin-left: -20px;
					}
				}
    }
  }
}
</style>
